export interface ICategoryBoxesCategory {
    categories: object;
    other: object;
}
